<template>
    <Historique/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
import Historique from "@/components/GesCom/Affectation/Historique.vue";

    export default defineComponent({
      name: "HistoriquePage",
      components: {
        
        Historique,
      },
    });
  </script>